export default {
  pageNotifications: []
};
